import * as React from "react";
import { Checkbox, DefaultButton, Dialog, DialogFooter, PrimaryButton, Spinner } from "office-ui-fabric-react";
import { useContext, useState } from "react";
import { IRole, IUserWithPhoto } from "../../../types/User.types";
import { getRoles, saveRoles } from "../../../api/userInfo";
import { ICheckboxStyles } from "@fluentui/react";
import { ProfileContext } from "../../../Home";

export interface IRoleAssignmentDialogProps {
    user: IUserWithPhoto;
    onDismiss: (saved: boolean) => void;
}

export const RoleAssignmentDialog = (props: IRoleAssignmentDialogProps) => {
    const userContext = useContext(ProfileContext);
    const [ loading, setLoading ] = useState(true);
    const [ roles, setRoles ] = useState<IRole[]|undefined>();
    const [ selectedRoles, setSelectedRoles ] = useState<number[]>([]);

    const loadRoles = async () => {
        const results = await getRoles();
        if (!(results instanceof Error)) {
            setLoading(false);
            setRoles(results);
            if (props.user.Roles) {
                setSelectedRoles(props.user.Roles.map(r => r.Id));
            }
        }
    }

    const submitNewRoles = async () => {
        const result = await saveRoles(props.user.Email, selectedRoles);
        if (result) {
            if (userContext && userContext.Profile.Email.toLowerCase() === props.user.Email) {
                userContext.onProfileUpdated(new AbortController());
            }
            props.onDismiss(true);
        } else {
            alert('Unable to save assigned roles. Please check the console for errors.');
        }
    }

    React.useEffect(() => {
        loadRoles();
    }, []);

    const checkboxStyle: ICheckboxStyles = {
        root: {
            paddingBottom: "10px"
        }
    }    

    return (
        <Dialog isOpen={true} dialogContentProps={{
            title: "Assign Roles"
        }}>
            { loading === true && (
                <Spinner label="Loading Roles" />
            )}
            { loading === false && roles && roles.length > 0 && roles.map((role) => (
                <Checkbox styles={checkboxStyle} key={role.Id} label={role.Name} checked={selectedRoles.indexOf(role.Id) >= 0} onChange={(e, checked) => {
                    if (selectedRoles.indexOf(role.Id) >= 0) {
                        setSelectedRoles(selectedRoles.filter((r) => r !== role.Id));
                    } else {
                        setSelectedRoles([...selectedRoles, role.Id]);
                    }
                }} />
            ))}
            <DialogFooter>
                <PrimaryButton label="Save" iconProps={{iconName: "Save"}} onClick={() => {
                    submitNewRoles();
                }} />
                <DefaultButton label="Cancel" iconProps={{iconName: "Cancel"}} onClick={() => {
                    props.onDismiss(false);
                }} />
            </DialogFooter>
        </Dialog>
    )
};
